"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllBrands = getAllBrands;
exports.getAllCategory = getAllCategory;
exports.getBrandsByCategory = getBrandsByCategory;
exports.getCategoryBanner = getCategoryBanner;
exports.getCategoryByLevel = getCategoryByLevel;
exports.getCategoryByParentId = getCategoryByParentId;
exports.getCategoryTree = getCategoryTree;
var _genericFetch = _interopRequireWildcard(require("../../../common/api/genericFetch"));
var _ApiConst = require("../../../common/utils/ApiConst");
var _utils = require("../../../common/utils/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function getCategoryByLevel(level, tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.CATEGORY_BY_LEVEL + `?level=${level}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getCategoryByParentId(parentId, tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.CATEGORY_BY_PARENTID + `?parentId=${parentId}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getCategoryBanner(categoryId, tokenData) {
  const apiEndPoint = _ApiConst.BASE_URL + _ApiConst.CATEGORY_BANNER + `-${categoryId}`;
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getAllBrands(params, tokenData) {
  const apiEndPoint = (0, _utils.buildUrl)(_ApiConst.SEARCH_SERVICE_BASE_URL + _ApiConst.NEW_BRANDS_API, params);
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getAllCategory(params, tokenData) {
  const apiEndPoint = (0, _utils.buildUrl)(_ApiConst.SEARCH_SERVICE_BASE_URL + _ApiConst.NEW_CATEGORY_API, params);
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getBrandsByCategory(params, tokenData) {
  const apiEndPoint = (0, _utils.buildUrl)(_ApiConst.SEARCH_SERVICE_BASE_URL + _ApiConst.BRAND_BY_CATEGORY, params);
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options
  });
}
function getCategoryTree(params, tokenData) {
  const apiEndPoint = _ApiConst.SEARCH_SERVICE_BASE_URL + (0, _ApiConst.CATEGORY_TREE)(params === null || params === void 0 ? void 0 : params.level, params === null || params === void 0 ? void 0 : params.subCategoryLevel);
  const options = (0, _genericFetch.enhanceWithToken)(tokenData);
  options.method = _ApiConst.API_PARAMS.GET;
  const formData = null;
  const enableCache = false;
  return (0, _genericFetch.default)({
    apiEndPoint,
    options,
    formData,
    enableCache
  });
}